import React, { useEffect } from "react";
import success from "../../assets/images/paymentsuccess.gif";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

const Success = () => {
  const navigate = useNavigate();
  const BASE_URL = `${process.env.REACT_APP_BASE_URL}`;

  useEffect(() => {
    const verifyPayment = async () => {
      const token = localStorage.getItem("accessToken");
      if (token) {
        try {
          const response = await axios.get(`${BASE_URL}stripe/payment-success`, {
            headers: {
              Authorization: `Bearer ${token}`
            }
          });
          if (response.data && response.data.header.code === 600) {
            localStorage.setItem("accessToken", response.data.body.value);
            toast.success("Payment verified! Your membership is now active.");
          }
        } catch (error) {
          console.error("Error verifying payment success:", error);
          toast.error("Could not sync subscription status with server.");
        }
      }
    };
    verifyPayment();
  }, [BASE_URL]);

  return (
    <>
      <div className="px-40 py-20">
        <div className="flex flex-col gap-10 items-center justify-center bg-gray-900 px-20 py-10 text-white rounded-lg">
          <img src={success} className="w-40 mx-auto" alt="success icon"/>
          <h1 className="text-2xl font-semibold">
            Your Payment is Successful
          </h1>
          <p className="text-center max-w-md">
            Thank you for your payment. Your membership has been upgraded. 
            An automated payment receipt will be sent to your registered email.
          </p>
          <button
            type="button"
            onClick={() => navigate("/")}
            className="px-6 py-2.5 text-sm font-semibold text-gray-900 bg-white rounded-lg hover:bg-gray-100 transition focus:outline-none"
          >
            Go to Home
          </button>
        </div>
      </div>
    </>
  );
};

export default Success;
